import { useCallback } from 'react'

import { useConversation } from '../../../../providers/ConversationProvider'
import { type ConversationTelemetryEvent } from '../../../../value-objects/ConversationTelemetryEvent'
import {
  type ConversationChoiceOption,
  type ConversationTurnItem,
} from '../../../../value-objects/ConversationTurnItem'
import { ConversationStreamStatuses } from '../../models/useConversationStream'

interface IUseRunConversationTurnPresenterResult {
  data: {
    items: ConversationTurnItem[]
    telemetry: ConversationTelemetryEvent[]
  }
  states: {
    isStreaming: boolean
    thinkingLabel: Nullable<string>
  }
  commands: {
    selectChoice: (option: ConversationChoiceOption) => void
  }
}

export const useRunConversationTurnPresenter =
  (): IUseRunConversationTurnPresenterResult => {
    const { items, status, thinkingLabel, telemetry, sendMessage } =
      useConversation()

    const selectChoice = useCallback(
      (option: ConversationChoiceOption) => sendMessage(option.message),
      [sendMessage]
    )

    return {
      data: { items, telemetry },
      states: {
        isStreaming: status === ConversationStreamStatuses.STREAMING,
        thinkingLabel,
      },
      commands: { selectChoice },
    }
  }
